// extracted by mini-css-extract-plugin
module.exports =  {"predictionBuilderDrawer":"predictionBuilderDrawer_QR6kf9Pq"};